import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormGroup, FormControl, Button } from 'react-bootstrap'
import styled from 'styled-components'

const StyledButton = styled(Button)`
  background: var(--clr-main);
  border: var(--clr-main);
  position: absolute;
  top: 2px;
  left: 155px;
  height: 30px;
`
const StyledForm = styled(FormGroup)`
  width: 200px;
`

const proptypes = {
  location: PropTypes.string.isRequired,
  query: PropTypes.object
}

class CustomerOverrideForm extends Component {
  constructor(props) {
    super(props)
    this.applyOverride = this.applyOverride.bind(this)
    this.state = {
      custOverride: ''
    }
  }

  updateFilter(e) {
    this.setState({ custOverride: e.target.value })
  }

  applyOverride(e) {
    e.preventDefault()
    window.location = `/?customer-override=${this.state.custOverride}`
  }

  render() {

    return (
      <form onSubmit={this.applyOverride}>
        <StyledForm role="form">
          <FormControl
            type="text"
            className="form-control"
            placeholder="Customer override"
            value={this.state.custOverride}
            onChange={this.updateFilter.bind(this)}
          />
          <StyledButton className="btn btn-primary"type="submit" >
            Go
          </StyledButton>
        </StyledForm>
      </form>
    )
  }
}

CustomerOverrideForm.propTypes = proptypes

export default CustomerOverrideForm



// WEBPACK FOOTER //
// ./src/components/CustomerOverrideForm/CustomerOverrideForm.js